import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 sales_rep_confirm_dispatch_delivery: { message: "idle" },
};

export const sales_rep_confirm_dispatch_delivery_Slice = createSlice({
 name: "sales_rep_confirm_dispatch_delivery",
 initialState,
 reducers: {
  success_sales_rep_confirm_dispatch_delivery: (state, action) => {
   state.sales_rep_confirm_dispatch_delivery = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_sales_rep_confirm_dispatch_delivery: (state, action) => {
   state.sales_rep_confirm_dispatch_delivery = { status: app_consts.FAIL, message: action.payload };
  },
  reset_sales_rep_confirm_dispatch_delivery: (state) => {
   state.sales_rep_confirm_dispatch_delivery = { status: app_consts.IDLE };
  },
  loading_sales_rep_confirm_dispatch_delivery: (state) => {
   state.sales_rep_confirm_dispatch_delivery = { status: app_consts.LOADING };
  },
 }
});

export const { success_sales_rep_confirm_dispatch_delivery, fail_sales_rep_confirm_dispatch_delivery, reset_sales_rep_confirm_dispatch_delivery, loading_sales_rep_confirm_dispatch_delivery } = sales_rep_confirm_dispatch_delivery_Slice.actions;

export default sales_rep_confirm_dispatch_delivery_Slice.reducer;